import { ToastBarType } from '../types/toastBar.type';
import { TOAST_ICON } from './Offline';

const DEFAULT_DELAY = 3000;

/**
 * Minimum pause before the same slow-request feedback (toast or popup) is shown again.
 *
 * On a consistently bad connection every single request crosses the threshold; without the pause the
 * toast would never leave the screen and a popup the user just dismissed would immediately return.
 */
export const SLOW_FEEDBACK_COOLDOWN_MS = 10000;

/** Builds the "your request is taking a while" toast — same icon and duration as the offline one. */
export const buildSlowConnectionToast = (message: string): ToastBarType => ({ message, iconName: TOAST_ICON, delay: DEFAULT_DELAY });
